import {FC} from 'react'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Avatar} from '@/components/ui/avatar/Avatar'
import {Text} from '@/components/ui/text/Text'
import {Button} from '@/components/ui/button/Button'
import {XCloseIcon} from '@/components/ui/icon/Icon'
import {GroupMember} from '@/features/users/types'
import {StyledUserRow} from './style'

interface SelectedUserRowProps {
    user: GroupMember
    onRemove: (userId: string) => void
}

export const SelectedUserRow: FC<SelectedUserRowProps> = ({user, onRemove}) => {
    return (
        <StyledUserRow columns={3} gap={2} fullWidth>
            <Flexbox align="center" gap={4}>
                <Avatar name={`${user.firstName} ${user.lastName}`} size="sm" />
                <Flexbox direction="column" gap={1}>
                    <Text size="textMd" weight="500">
                        {user.firstName} {user.lastName}
                    </Text>
                    <Text size="textSm" weight="400" palette="neutral" shade="500">
                        {user.email}
                    </Text>
                </Flexbox>
            </Flexbox>
            <Button variant="ghostDanger" shape="circle" size="sm" onClick={() => onRemove(user.id)}>
                <XCloseIcon />
            </Button>
        </StyledUserRow>
    )
}
